module.exports = __webpack_public_path__ + "static/media/pets_icon.7a2d5f8a.svg";